var _a;

export var STATUS_MAPPING = {
  INVOICED_NOT_SELF: 18001,
  OUT_OF_TIME_RANGE: 18002,
  ALREADY_ABANDONED: 18003,
  MERCHANT_NOT_EXIST: 17025,
  TAXATION_NOT_EXIST: 17026 // 税盘信息不存在

};
export var INVOICE_STATUS_MAPPING = {
  INVOICED_NOT_SELF: 607,
  OUT_OF_TIME_RANGE: 608,
  ALREADY_ABANDONED: 609,
  MERCHANT_NOT_EXIST: 610,
  TAXATION_NOT_EXIST: 611 // 税盘信息不存在

};
export var BIZTYPE_MAP = {
  11: "paotui",
  24: "waimai",
  60: "wmshangjia-app-pt" // 跑腿B端开票biztype

};
export var BIZTYPE = {
  WAIMAI: 24,
  //啡快和空间预定的bizType
  FeiKuai: 113,
  KongJian: 109,
  ZhuanYeBan_ShouYin: 22,
  ZhiNengBan_ShouYin: 23,
  PaoTui: 11,
  PaoTuiB: 110,
  ShanGou: 137,
  XiaoXiangN: 139 // 小象 N 项目

};
export var SUBBIZTYPE = {
  YIYAO: 14090,
  PEISONGFEI: 64151515,
  ORDER: 76686 //外卖订单

};
export var APP_CHANNEL_BIZTYPE_MAP = {
  "waimai-mine": 24,
  "QIXING": 108
};
/**
 * H5配送费，不同业务的开票最大可勾选笔数
 */

export var DELIVERY_MAX_SELECT_NUM = {
  WAIMAI: 1000,
  OTHERS: 100 // 其他业务

};
/**
 * 前台码上报埋点时用于区分业务方、业务场景的参数
 */

export var QIAN_TAI_MA_SOURCE_MAP = (_a = {},
/**
 * 专业版收银
 */
_a[BIZTYPE.ZhuanYeBan_ShouYin] = {
  businessSource: 'zhuanye_shouyin',
  businessSourceFrom: 'zhuanye_shouyin_qiantaima'
},
/**
 * 智能版收银
 */
_a[BIZTYPE.ZhiNengBan_ShouYin] = {
  businessSource: 'zhineng_shouyin',
  businessSourceFrom: 'zhineng_shouyin_qiantaima'
}, _a);
/**
 * 发票内容类型
 */

export var INVOICE_CONTENT_TYPE = {
  GOODS_DETAILS: 0,
  GOODS_CATEGORY: 1 // 商品大类

};